import { render, staticRenderFns } from "./OrphanFlux.vue?vue&type=template&id=a96a0e78&"
import script from "./OrphanFlux.vue?vue&type=script&lang=js&"
export * from "./OrphanFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a96a0e78')) {
      api.createRecord('a96a0e78', component.options)
    } else {
      api.reload('a96a0e78', component.options)
    }
    module.hot.accept("./OrphanFlux.vue?vue&type=template&id=a96a0e78&", function () {
      api.rerender('a96a0e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orphan/OrphanFlux.vue"
export default component.exports